import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as TextManager from "../modules/languages/TextManager";
import NumberFormat from 'react-number-format';
import Alert from "./Alert";
import * as http from "../modules/http";


class ModalHotCustomer extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            //modal: true,
            warning: '',
            errorText: '',
            showNotEligibility: false,
            payment: props.data && props.data.email ? props.data.payment : '',
            phone: props.data && props.data.phone_number ? props.data.phone_number : ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }

    send = () => {

        if (this.state.payment === '' && this.state.phone === '') {
            this.setState({warning: 'שדה דוא\'ל או מספר טלפון - חובה'});
            return;
        }

        if(this.state.phone.length > 0 && this.state.phone.length !== 10) {
            this.setState({warning: "מספר מנוי חייב להיות באורך של 10 מספרים"});
            return;
        }

        this.setState({warning: ''});

        http.postToServer(
            'customers/check_hot_customer_eligibikity?passport=' + this.props.passport + '&phone=' + this.state.phone + '&last_payment=' + this.state.payment,
            {},
            (response) => {

                //console.log(response.data)

                if (response.data.isExist) {
                    this.props.saveHotAutoData(this.state.phone, response.data.phoneNumber, this.state.payment,
                        response.data.cityName, response.data.streetName, response.data.houseNum,
                        response.data.customerNumber, response.data.email, response.data.customerName);

                    this.props.toggle();
                }
                else {
                    this.setState({phone: '', payment: '', showNotEligibility: true})
                }
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
            }
        );

    };

    toggle = () => {
        this.props.toggle();
    };

    render() {

        let Icon;
        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.props.isHotCustomer} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>}
                            <Row style={{flexDirection: "row-reverse"}}>
                                <Alert color='primary' className='alert--bordered'>
                                    <h4 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>לקוח יקר המערכת זיהתה כי הלקוח אותך אתה מחבר, הינו לקוח קיים בחברת הוט מובייל</span>
                                    </h4>
                                    <h5 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>:על מנת לחברו בתהליך אוטומטי (יחובר עם רובוט עד 5 דק') אנא הזן</span>
                                    </h5>
                                </Alert>
                            </Row>
                            {this.state.showNotEligibility && <Row style={{flexDirection: "row-reverse"}}>
                                <Alert color='primary' className='alert--bordered'>
                                    <h4 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>הפרטים שהוזנו אינם תואמים את הנתונים הקיימים המערכות של הוט מובייל</span>
                                    </h4>
                                </Alert>
                            </Row>}
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    <Row style={{flexDirection: "row-reverse"}}>
                                                        <Col md={3} xs={12}>
                                                            <label className="form__form-group-label">
                                                                מספר מנוי קיים בהוט
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <input name="customerName"
                                                                       style={{backgroundColor: '#F0F8FF'}}
                                                                       value={this.state.phone}
                                                                       type="text"
                                                                       dir={"auto"}
                                                                       onKeyPress={(event) => {
                                                                           if (!/[0-9]/.test(event.key)) {
                                                                               event.preventDefault();
                                                                           }
                                                                       }}
                                                                       onChange={(event) =>
                                                                           this.setState({phone: event.target.value})}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <div className="form__form-group" style={{paddingTop: '0.5rem'}}></div>

                                                    <Row style={{flexDirection: "row-reverse"}}>
                                                        <Col md={4} xs={12}>
                                                            <label className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Sales.salesItem.hotSpecial}<label>{'\xa0'}4</label>
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <input name="customerName"
                                                                       style={{backgroundColor: '#F0F8FF', maxWidth: '70%'}}
                                                                       value={this.state.payment}
                                                                       type="text"
                                                                       dir={"auto"}
                                                                       onKeyPress={(event) => {
                                                                           if (!/[0-9]/.test(event.key)) {
                                                                               event.preventDefault();
                                                                           }
                                                                       }}
                                                                      onChange={(event) =>
                                                                          this.setState({payment: event.target.value})}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                            <ButtonToolbar className='modal__footer' style={{marginTop: 0, marginRight: 0}}>
                                <Button outline={this.props.colored} color={this.props.color}
                                        onClick={this.send}>
                                    אישור ✔️</Button>
                            </ButtonToolbar>
                            <Row style={{flexDirection: "row-reverse"}}>
                                <Alert color='primary' className='alert--bordered'>
                                    <h4 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>אם אין לכם את הפרטים של הלקוח ותרצו שהעסקה תחובר על ידי נציגי התפעול שלנו אנא לחצו כאן </span>
                                    </h4>
                                </Alert>
                            </Row>
                            <ButtonToolbar className='modal__footer' style={{marginTop: 0, marginRight: 0}}>
                                <Button outline={this.props.colored} color={this.props.color}
                                        onClick={this.toggle}>חיבור ע"י נציגי התפעול ✔️</Button>{' '}
                            </ButtonToolbar>
                        </Container>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalHotCustomer))